import { Component, inject } from '@angular/core';
import { ModalService } from '@malirang/front-share';
import InfoModal from './modals/info/info.modal';

@Component({
  selector: 'app-chatbot',
  imports: [],
  templateUrl: './chatbot.component.html',
  styleUrl: './chatbot.component.css',
})
export class ChatbotComponent {
  readonly modalService = inject(ModalService);

  /**
   * @name openChatbot
   * @description 챗봇 모달 열기
   * @param {Event} ev
   * @returns {void}
   */
  openChatbot(ev?: Event): void {
    ev?.stopPropagation();
    ev?.preventDefault();
    this.modalService.create(InfoModal);
  }
}
